import React from "react";

const TabSwitcher = ({activeTab, onTabChange}) => (
    <div className="flex justify-center mb-4 p-1 rounded bg-gray-300 bg-offWhite text-sm font-bold w-2/3">
        <button
            className={`px-2 py-1 rounded w-40 ${activeTab === 'firmenprojekte' ? 'bg-white text-mainBlue' : 'bg-grey-400 text-gray-600'}`}
            onClick={() => onTabChange('firmenprojekte')}
        >
            FIRMENPROJEKTE
        </button>
        <button
            className={`px-2 py-1 rounded w-40 ${activeTab === 'mitarbeiter' ? 'bg-white text-mainBlue' : 'bg-grey-400 text-gray-600'}`}
            onClick={() => onTabChange('mitarbeiter')}
        >
            MITARBEITER
        </button>
    </div>
);

export default TabSwitcher;
